const networkListColumn = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Label",
    dataIndex: "label_fr",
    key: "label_fr",
  },
  {
    title: "Enseigne id",
    dataIndex: "retailer_id",
    key: "retailer_id",
  },
  {
    title: "Enseigne label",
    dataIndex: "retailer_label",
    key: "retailer_label",
  },
]

export default networkListColumn;


// WEBPACK FOOTER //
// src/containers/admin/network/NetworksList.utils.js